<template>
  <div id="app">
    <router-view />
    <van-tabbar v-if="showTabbar" inactive-color="#9CA3AF" v-model="active">
      <van-tabbar-item @click="handleTabbarClick('/')" :class="{ active: currentPath === '/' }">
        <template #icon>
          <van-icon name="wap-home" />
        </template>
        首页
      </van-tabbar-item>
      <van-tabbar-item @click="handleTabbarClick('/students')" :class="{ active: currentPath === '/students' }">
        <template #icon>
          <img :src="currentPath === '/students' ? icon.active : icon.inactive" class="icon-student" />
        </template>
        学生资料
      </van-tabbar-item>
      <van-tabbar-item @click="handleTabbarClick('/user')" :class="{ active: currentPath === '/user' }">
        <template #icon>
          <van-icon name="manager" />
        </template>
        个人中心
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue';

const active = ref(5);
const icon = {
  active: require('./assets/icons/student-active.svg'),
  inactive: require('./assets/icons/student.svg'),
};

// 当前路径
const currentPath = ref(window.location.pathname);

// 需要显示tabbar的路由
const showTabbar = computed(() => {
  return ['/', '/students', '/user'].includes(currentPath.value);
});

// tabbar点击事件处理
const handleTabbarClick = (path) => {
  // 如果点击的是当前页面，不进行跳转
  if (currentPath.value === path) {
    return;
  }
  currentPath.value = path;
  window.location.href = path;
};
</script>

<style>
body, #app {
  height: 100vh;
  margin: 0;
  background: #F9FAFB;
  font-size: 14px;
}
.icon-student {
  width: 18px !important;
  height: 18px !important;
  padding: 2px;
}
.van-tabbar-item.active {
  color: var(--van-primary-color) !important;
}
</style>
